import { classNames } from "../../../../../lib/classNames"

interface RadioButtonProps {
  checked: boolean
  className?: string
  label?: string
  disabled?: boolean
  error?: boolean
}

export function RadioButton({
  checked,
  className,
  disabled,
  error,
  label,
}: RadioButtonProps) {
  return (
    <div
      className={classNames(
        "group flex flex-row items-center gap-x-2",
        className
      )}
      data-checked={checked || undefined}
      data-disabled={disabled || undefined}
      data-error={error || undefined}
    >
      <div
        className={classNames(
          "border-v2-border-stronger flex size-4 items-center justify-center rounded-full border-[1.5px]",
          "group-hover:not-group-data-disabled:not-group-data-error:ring-6 group-hover:not-group-data-disabled:not-group-data-error:ring-v2-background-active-hover group-hover:not-group-data-disabled:not-group-data-error:not-group-data-checked:border-v2-border-active",
          "group-data-checked:border-5 group-data-checked:border-v2-background-primary",
          "group-data-disabled:border-v2-border-strong group-data-disabled:bg-v2-background-surface-tonal group-data-checked:group-data-disabled:border-v2-background-primary-disabled group-data-checked:group-data-disabled:bg-transparent",
          "group-data-error:border-2 group-data-error:border-v2-border-danger"
        )}
      />
      {label && (
        <div className="text-body color-default group-data-disabled:color-disabled grow select-none">
          {label}
        </div>
      )}
    </div>
  )
}
